import { BaseService } from "mrb/core";
import LoadioDeviceContentProfileApiRouteService from "./LoadioDeviceContentProfileApiRouteService";

class LoadioDeviceContentProfileService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LoadioDeviceContentProfileApiRouteService());
    }

    find(filter, abortSignal = null) {
        const url = this.routeService.find(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    assignProfile(deviceId, loadioContentProfileId, abortSignal = null) {
        const url = this.routeService.assignProfile(deviceId);
        return this.apiClient.patch(url, { loadioContentProfileId }, null, abortSignal);
    }

    batchAssignProfile(deviceIds, loadioContentProfileId, abortSignal = null) {
        const url = this.routeService.batchAssignProfile();
        return this.apiClient.patch(url, { deviceIds, loadioContentProfileId }, null, abortSignal);
    }
}

export default LoadioDeviceContentProfileService;
